import React from "react";

const CloudIcon = ({ fill = "#333333", ...delegated }) => {
  return (
    <svg
      width="40"
      height="29"
      viewBox="0 0 40 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...delegated}
    >
      <path
        d="M22.125 6.48267C20.75 4.92017 18.75 3.85767 16.5 3.85767C12.3125 3.85767 9 7.23267 9 11.3577V11.4202C9 12.6702 8.1875 13.7952 7 14.2327C4.625 15.0452 3 17.2952 3 19.8577C3 23.1702 5.6875 25.8577 9 25.8577H31.5H31.6875C31.6875 25.8577 31.75 25.8577 31.8125 25.8577C34.6875 25.7327 37 23.2952 37 20.3577C37 18.1077 35.625 16.1702 33.6875 15.3577C32.4375 14.7952 31.6875 13.4827 31.9375 12.1077C31.9375 11.8577 32 11.6077 32 11.3577C32 8.92017 29.9375 6.85767 27.5 6.85767C26.8125 6.85767 26.1875 7.04517 25.625 7.29517C24.4375 7.79517 23 7.48267 22.125 6.48267ZM32 28.8577H31.5H29H9C4 28.8577 0 24.8577 0 19.8577C0 15.9827 2.5 12.6077 6 11.4202V11.3577C6 5.60767 10.6875 0.857666 16.5 0.857666C19.625 0.857666 22.5 2.29517 24.4375 4.54517C25.375 4.10767 26.375 3.85767 27.5 3.85767C31.625 3.85767 35 7.23267 35 11.3577C35 11.7952 34.9375 12.1702 34.875 12.6077C37.875 13.9202 40 16.9202 40 20.3577C40 24.9202 36.4375 28.6077 32 28.8577ZM13.9375 18.4202C13.3125 17.8577 13.3125 16.9202 13.9375 16.3577C14.5 15.7327 15.4375 15.7327 16.0625 16.3577L18.5 18.7952V10.3577C18.5 9.54517 19.125 8.85767 20 8.85767C20.8125 8.85767 21.5 9.54517 21.5 10.3577V18.7952L23.9375 16.3577C24.5 15.7327 25.4375 15.7327 26 16.3577C26.625 16.9202 26.625 17.8577 26 18.4202L21 23.4202C20.4375 24.0452 19.5 24.0452 18.9375 23.4202L13.9375 18.4202Z"
        fill={fill}
      />
    </svg>
  );
};

export { CloudIcon };
